<div class="int-text">
  <mark>Interested in partnering with us?</mark>
  <img class="arrow-img" src="assets/images/arrow.svg">
</div>

<div class="contact-us section-info">
  <div class="img-bg">
    <div class="bg-dark">
      <div class="main-container">
        <div class="container">
          <mat-icon>pin_drop</mat-icon>
          <div class="text">
            <span class="info">Address</span>
            <p class="sub-info">Yerevan, Armenia</p>
          </div>
        </div>
        <div class="container">
          <mat-icon>phone</mat-icon>
          <div class="text">
            <span class="info">Phone</span>
            <p class="sub-info">+374 98 178384</p>
          </div>
        </div>
        <div class="container">
          <mat-icon>email</mat-icon>
          <div class="text">
            <span class="info">Email</span>
            <p>
              <a href="mailto:contact@capitalsoft.am" class="sub-info">contact@capitalsoft.am</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="feed-back">
    <app-feedback-form></app-feedback-form>
  </div>

</div>
